module.exports = __webpack_public_path__ + "static/about_simulator_clouds_art@2x-536c3010642ff8ae3a52ae42be7cb75a.png";